const auditApi = ({ apiClient }) => ({
  list(params, headers = {}) {
    return apiClient.get('reports/audit', {}, params, headers)
  },
})

export default auditApi
